(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-cart-modal")) {
  customElements.define(
    "s-cart-modal",
    class SectionCartModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        this.body = document.querySelector("body");
        this.overlay = document.querySelector(".js-overlay");
        this.headerItemCount = document.querySelector(".js-header__cart-count");

        this.addEventsListeners();

        window.PubSub.subscribe("cart-modal:open", this.openerModal);
        window.PubSub.subscribe("cart:update", this.updateCart);
      }

      disconnectedCallback() {
        this.btnCloser.removeEventListener("click", this.closerModal);
      }

      updateCart = () => {
        this.classList.add("is-loading");

        const cartModalBody = this.querySelector(".js-cart-modal__body");
        const scrollPosition = cartModalBody ? cartModalBody.scrollTop : 0;
        fetch(window.Shopify.routes.root + "?section_id=" + this.sectionId)
          .then((response) => response.text())
          .then((html) => {

            let newSection = document.createElement("div");
            newSection.innerHTML = html;

            let newCartModal = newSection.querySelector(".s-cart-modal");
            if (newCartModal.dataset.collectionHandle) {
              this.dataset.collectionHandle =
                newCartModal.dataset.collectionHandle;
            }

            if (newCartModal.innerHTML) {
              this.innerHTML = newCartModal.innerHTML;
            }

            this.classList.remove("is-loading");

            const updatedCartModalBody = this.querySelector(
              ".js-cart-modal__body"
            );

            if (updatedCartModalBody) {
              updatedCartModalBody.scrollTop = scrollPosition;
            }

            if (this.querySelector(".js-cart-modal__count")?.innerHTML) {

              this.headerItemCount.innerHTML = this.querySelector(
                ".js-cart-modal__count"
              ).innerHTML;
            }


            this.addEventsListeners();
          })
          .catch((error) => console.error(error));
      };

      addEventsListeners = () => {

        this.btnCloser = this.querySelector(".js-cart-modal__closer");
        this.btnCloser.addEventListener("click", this.closerModal);
      };

      closerModal = () => {
        this.body.classList.remove("modal-open");
        this.overlay.classList.remove("is-open");
        this.classList.remove("is-open");

        this.overlay.removeEventListener("click", this.closerModal);
      };

      openerModal = () => {
        window.location.href = '/cart'

        // this.body.classList.add("modal-open");
        // this.overlay.classList.add("is-open");
        // this.classList.add("is-open");

        // this.updateCart(); 

        // this.overlay.addEventListener("click", this.closerModal);
        // this.btnCloser = this.querySelector(".js-cart-modal__closer");
        // this.btnCloser.addEventListener("click", this.closerModal);

      };
    }
  );
}

},{}]},{},[1])

